import { categoryZones } from '@/mocks/homeData';

const toneClasses: Record<string, { wrap: string; no: string; meta: string; desc: string; icon: string }> = {
  primary: {
    wrap: 'bg-primary-500 text-background-50 border-primary-500',
    no: 'text-background-100/70',
    meta: 'text-accent-200',
    desc: 'text-background-100/90',
    icon: 'text-background-50',
  },
  plain: {
    wrap: 'bg-background-50 text-foreground-950 border-background-200',
    no: 'text-background-400',
    meta: 'text-secondary-700',
    desc: 'text-foreground-600',
    icon: 'text-primary-500',
  },
  accent: {
    wrap: 'bg-accent-100 text-foreground-950 border-accent-300',
    no: 'text-accent-700/70',
    meta: 'text-accent-800',
    desc: 'text-foreground-700',
    icon: 'text-accent-700',
  },
  secondary: {
    wrap: 'bg-secondary-100 text-foreground-950 border-secondary-300',
    no: 'text-secondary-700/60',
    meta: 'text-secondary-800',
    desc: 'text-foreground-700',
    icon: 'text-secondary-800',
  },
};

export default function CategoryZones() {
  return (
    <section id="zones" className="w-full bg-background-100">
      <div className="w-full px-4 py-16 md:px-10 md:py-24">
        <div className="flex flex-col gap-5 border-b border-background-200 pb-8 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="text-xs tracking-[0.32em] text-primary-600">SECTIONS</p>
            <h2 className="mt-5 font-heading text-3xl font-bold tracking-tight text-foreground-950 md:text-4xl">
              分区合集
            </h2>
          </div>
          <p className="max-w-md text-sm leading-loose text-foreground-600">
            内容按题材分成四个常设分区，各有固定的更新节奏。挑一个顺眼的分区，从这里开始翻。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 md:gap-5 lg:grid-cols-4">
          {categoryZones.map((zone) => {
            const tone = toneClasses[zone.tone];
            return (
              <a
                key={zone.no}
                href="#index"
                className={`group flex cursor-pointer flex-col justify-between rounded-lg border p-6 transition-transform duration-300 hover:-translate-y-1 md:p-7 ${tone.wrap}`}
              >
                <div className="flex items-start justify-between">
                  <span className={`font-heading text-3xl tabular-nums ${tone.no}`}>{zone.no}</span>
                  <span className={`flex h-9 w-9 items-center justify-center rounded-full ${tone.icon}`}>
                    <i className="ri-arrow-right-up-line text-lg"></i>
                  </span>
                </div>
                <div className="mt-14">
                  <h3 className="font-heading text-xl font-bold tracking-tight md:text-2xl">
                    {zone.name}
                  </h3>
                  <p className={`mt-2 text-xs tracking-wider ${tone.meta}`}>{zone.count}</p>
                  <p className={`mt-4 text-sm leading-relaxed ${tone.desc}`}>{zone.desc}</p>
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}